var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-view-heading"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{class:("col-" + _vm.firstColumnWidth + " col-12-md")},[_vm._t("default",[_c('h1',[_vm._v(_vm._s(_vm.title))])])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }